export default __webpack_public_path__ + "static/media/YufangGTestimonial.4ed6e15d.png";